module.exports = {
    message: {
      Resut:{
        title:'比赛成绩',
        session: '单元',
        sessionAll: '全部',
        umpire: '主裁',
        serverUmpire:'发球裁判',
        description1: '暂时没有符合条件的比赛。',
        description2: '当前赛事还没安排相关的比赛。',
        Medal: '奖牌榜',
        Gold: '金牌',
        Silver: '银牌',
        Bronze: '铜牌',
        nodata:'暂无相关数据。',
        noFile:'暂时还没上传文件。',
        searchFile:'请输入要搜索的文件'
      },
      SearchCond:{
        SearchAth: '搜索运动员',
        SearchAthTips: '请输入运动员姓名',
        Court: '场地',
        CourtTips: '请选择',
        Status: '比赛状态',
        SearchBtn: '搜索'
      }
    },
    
}